/**
 * Solo orchestrazione mutazioni Calendario (store/API). Nessun DOM.
 * Errori sempre come Error con messaggio leggibile — niente aggiornamento locale parziale lato API.
 */

import {
  addCalendarTemplate,
  updateCalendarTemplate,
  deleteCalendarTemplate,
  addCalendarModification,
  deleteCalendarModification,
} from '../store.js';

function normalizeError(err, fallback) {
  const msg = String(err?.message ?? err ?? '').trim() || fallback;
  const out = new Error(msg);
  if (err && typeof err === 'object' && 'cause' in err && err.cause !== undefined) {
    try {
      Object.defineProperty(out, 'cause', { value: err.cause, enumerable: false });
    } catch {
      /* ignore */
    }
  }
  return out;
}

/** Crea slot ricorrente — fallimento: stato invariato (store aggiorna solo dopo await ok). */
export async function calendarCreateTemplate(payload) {
  try {
    return await addCalendarTemplate(payload);
  } catch (e) {
    throw normalizeError(e, 'Impossibile creare lo slot ricorrente.');
  }
}

export async function calendarUpdateTemplate(id, patch) {
  try {
    return await updateCalendarTemplate(id, patch);
  } catch (e) {
    throw normalizeError(e, 'Impossibile aggiornare lo slot ricorrente.');
  }
}

export async function calendarDeleteTemplate(id) {
  try {
    return await deleteCalendarTemplate(id);
  } catch (e) {
    throw normalizeError(e, 'Impossibile rimuovere lo slot ricorrente.');
  }
}

export async function calendarCreateModification(mod) {
  try {
    return await addCalendarModification(mod);
  } catch (e) {
    throw normalizeError(e, 'Impossibile applicare la modifica al calendario.');
  }
}

export async function calendarDeleteModification(id) {
  try {
    return await deleteCalendarModification(id);
  } catch (e) {
    throw normalizeError(e, 'Impossibile rimuovere la modifica.');
  }
}
